import ReactDatePicker, { ReactDatePickerCustomHeaderProps, ReactDatePickerProps } from 'react-datepicker';
import { ko } from 'date-fns/locale';
import Header from '@common/periodCalendar/common/Header';

import classnames from 'classnames/bind';
import style from './datePicker.module.scss';
const cx = classnames.bind(style);

export type PeriodCalendarProps = ReactDatePickerProps & {};

const renderCustomHeader = (props: ReactDatePickerCustomHeaderProps) => <Header {...props} />;

const renderDayContents = (dayOfMonth: number) => <>{dayOfMonth}</>;

/**일요일에 해당하는 요소는 sunday클래스를 추가(border-left css적용하기 위함) */
const dayClassName = (date: Date) => {
  const isSunday = date.getDay() === 0;
  if (isSunday) return 'sunday';
  return null;
};

const PeriodCalendar = (props: PeriodCalendarProps) => {
  return (
    <div className={cx('wrap')}>
      <ReactDatePicker
        locale={ko}
        dateFormat={'yyyy. MM. dd'}
        dayClassName={dayClassName}
        renderDayContents={renderDayContents}
        renderCustomHeader={renderCustomHeader}
        disabledKeyboardNavigation
        showFourColumnMonthYearPicker
        shouldCloseOnSelect={false}
        showPopperArrow={false}
        yearItemNumber={12}
        inline={true}
        {...props}
      />
    </div>
  );
};

export default PeriodCalendar;
